import { msg } from "@lingui/macro";
import type { MessageDescriptor } from "@lingui/core";
import { constructorSearchAdapter } from "src/adapters/search/constructor";
import type {
  ListingFacetKeys,
  ListingSortKeys,
} from "src/types/adapters/listing.type";
import type { SearchStrategyMap } from "src/types/strategies/search.type";

export const SEARCH_STRATEGY_MAP = {
  constructor: constructorSearchAdapter,
} satisfies SearchStrategyMap;

export const FACET_LABELS: Record<ListingFacetKeys, MessageDescriptor> = {
  brands: msg`Brands`,
  category: msg`Categories`,
  colors: msg`Colours`,
  discount: msg`Discount`,
  genders: msg`Department`,
  pattern: msg`Pattern`,
  price: msg`Price`,
  size: msg`Size`,
  style: msg`Style`,
  collections: msg`Collections`,
};

export const ORDER_BY_PARAM = "orderBy";

export const MAP_SORT_TO_URL_VALUE = {
  new: "new",
  "new-discount": "new-discount",
  "price-high-to-low": "price-desc",
  "price-low-to-high": "price-asc",
  popularity: "popular",
} as const satisfies Record<ListingSortKeys, string>;

export const MAP_URL_VALUE_TO_SORT = Object.fromEntries(
  Object.entries(MAP_SORT_TO_URL_VALUE).map(([k, v]) => [v, k])
) as Record<string, ListingSortKeys>;
